export default __webpack_public_path__ + "fonts/personal_1.bcb13a272501c1576709bdc6e5eb8d9c.png";